import { render, staticRenderFns } from "./ClassSelector.vue?vue&type=template&id=6efb47e4&scoped=true&"
import script from "./ClassSelector.vue?vue&type=script&lang=ts&"
export * from "./ClassSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ClassSelector.vue?vue&type=style&index=0&id=6efb47e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efb47e4",
  null
  
)

export default component.exports